"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTableBody = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var react_1 = require("react");
var buttons_1 = require("../buttons");
var Checkbox_1 = require("../Checkbox");
var TextLink_1 = require("../TextLink");
var Typography_1 = require("../Typography");
var DataCell_1 = require("./DataCell");
var DataTableContext_1 = require("./DataTableContext");
var DataTableBody = function (_a) {
    var columns = _a.columns, idExtractor = _a.idExtractor, selectable = _a.selectable, expandable = _a.expandable, renderColumns = _a.renderColumns, renderExpand = _a.renderExpand, expand = _a.expand, expandedKeys = _a.expandedKeys, onRowExpand = _a.onRowExpand, actions = _a.actions, onRowClick = _a.onRowClick, bordered = _a.bordered, tdClassName = _a.tdClassName, testId = _a["data-testid"];
    var _b = (0, DataTableContext_1.useTableContext)(), onSelect = _b.onSelect, selectedRows = _b.selectedRows, expanded = _b.expanded, onExpand = _b.onExpand, data = _b.data;
    if (!data || data.length < 0) {
        return null;
    }
    var handleSelect = function (key, value) { return function () {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(key, value);
    }; };
    var handleExpand = function (key) { return function () {
        if (expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.includes(key.toString())) {
            onRowExpand === null || onRowExpand === void 0 ? void 0 : onRowExpand(key);
        }
        else {
            onExpand === null || onExpand === void 0 ? void 0 : onExpand(key);
        }
    }; };
    var handleActionClick = function (item, onClick) { return function (event) {
        onClick === null || onClick === void 0 ? void 0 : onClick(event, item);
    }; };
    var handleRowClick = function (item) { return function () {
        onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(item);
    }; };
    return ((0, jsx_runtime_1.jsx)("tbody", __assign({ "data-testid": "".concat(testId, "TableBody") }, { children: data === null || data === void 0 ? void 0 : data.map(function (obj, index) {
            var item = obj;
            var key = (idExtractor === null || idExtractor === void 0 ? void 0 : idExtractor(item, index)) || index.toString();
            var isSelected = !!(selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.find(function (s) { return s.rowId === key; }));
            var selectableCell;
            if (selectable) {
                selectableCell = ((0, jsx_runtime_1.jsx)(DataCell_1.default, __assign({ innerDiv: true, leading: true }, { children: (0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { checked: isSelected, onChange: handleSelect(key, item) }) })));
            }
            var expandableCell;
            var canExpand = ((expand === null || expand === void 0 ? void 0 : expand(item)) || true) && renderExpand && expandable;
            if (canExpand) {
                expandableCell = ((0, jsx_runtime_1.jsx)(DataCell_1.default, __assign({ innerDiv: true, tdClassName: tdClassName, className: "squid-flex-1" }, { children: (0, jsx_runtime_1.jsx)(buttons_1.SimpleButton, { "aria-label": expanded.includes(key) || (expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.includes(key))
                            ? 'Close'
                            : 'Open', rightIcon: expanded.includes(key) || (expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.includes(key))
                            ? 'ChevronUp'
                            : 'ChevronDown', rightIconSize: "md", className: "squid-text-alias-color-text-base", onClick: handleExpand(key) }) })));
            }
            var expandedContent;
            if ((canExpand && expanded.includes(key)) ||
                (expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.includes(key))) {
                var expandedSpan = Number(!!selectable) +
                    Number(!!expandable) +
                    Number((actions === null || actions === void 0 ? void 0 : actions.length) > 0) +
                    columns.length;
                expandedContent = ((0, jsx_runtime_1.jsx)("tr", __assign({ className: "squid-border-b squid-border-alias-color-border-base hover:squid-bg-alias-state-base-hover" }, { children: (0, jsx_runtime_1.jsx)(DataCell_1.default, __assign({ innerDiv: false, colSpan: expandedSpan }, { children: renderExpand(item) })) }), "".concat(key, "_expanded")));
            }
            var actionCell;
            if ((actions === null || actions === void 0 ? void 0 : actions.length) > 0) {
                actionCell = ((0, jsx_runtime_1.jsx)(DataCell_1.default, __assign({ innerDiv: true, className: "squid-flex-row", tdClassName: tdClassName }, { children: actions
                        .filter(function (action) { return !action.canShow || action.canShow(item); })
                        .map(function (action, index) {
                        var _a, _b, _c;
                        var iconPosition = (_a = action.iconPosition) !== null && _a !== void 0 ? _a : 'left';
                        if (action.variant === 'link') {
                            return ((0, jsx_runtime_1.jsx)(TextLink_1.TextLink, __assign({ className: action.className, strong: false, href: action.href, rel: action.rel, target: action.target, onClick: handleActionClick(item, action.onClick), underline: false }, { children: action.title }), action.title));
                        }
                        return ((0, jsx_runtime_1.jsx)(buttons_1.SimpleButton, { title: action.title, "aria-label": (_b = action.title) !== null && _b !== void 0 ? _b : 'Perform Action', variant: action.variant, leftIcon: iconPosition === 'left' ? action.icon : undefined, leftIconSize: action.iconSize, leftIconOutlined: action.iconOutlined, rightIcon: iconPosition === 'right' ? action.icon : undefined, rightIconSize: action.iconSize, rightIconOutlined: action.iconOutlined, className: action.className, onClick: handleActionClick(item, action.onClick) }, (_c = action.title) !== null && _c !== void 0 ? _c : "".concat(index, "_action_btn")));
                    }) })));
            }
            var content;
            if (renderColumns) {
                content = renderColumns(item, index);
            }
            else {
                content = ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: columns.map(function (column, columnIndex) {
                        var value = item[column.name];
                        var cellContent;
                        if (column.render) {
                            cellContent = column.render(item);
                        }
                        else {
                            cellContent = ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('squid-flex squid-flex-1 squid-items-center squid-gap-component-table-cell-space-base', {
                                    'squid-justify-center': column.align === 'center',
                                    'squid-justify-start': !column.align || column.align === 'left',
                                    'squid-justify-end': column.align === 'right',
                                }, tdClassName) }, { children: (0, jsx_runtime_1.jsx)(Typography_1.Label, __assign({ as: "h4", strong: false, color: "base" }, { children: value })) })));
                        }
                        return ((0, jsx_runtime_1.jsx)(DataCell_1.default, __assign({ innerDiv: false, colSpan: column.colSpan || 1, tdClassName: tdClassName }, { children: cellContent }), "".concat(key, "_").concat(column.name, "_").concat(columnIndex)));
                    }) }));
            }
            return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("tr", __assign({ "data-testid": "".concat(testId, "TableRow"), className: (0, classnames_1.default)('squid-border-b squid-border-alias-color-border-base hover:squid-bg-alias-state-base-hover', {
                            'squid-bg-alias-state-base-active': isSelected,
                            'last:squid-border-b-0': bordered,
                        }), onClick: !!onRowClick &&
                            !selectable &&
                            !expandable &&
                            (actions === null || actions === void 0 ? void 0 : actions.length) > 0
                            ? handleRowClick(item)
                            : undefined }, { children: [selectableCell, content, actionCell, expandableCell] })), expandedContent] }, key));
        }) })));
};
exports.DataTableBody = DataTableBody;
